// Form mode constants
export const FORM_MODES = {
  LOGIN: "login",
  REGISTER: "register",
  FORGOT_PASSWORD: "forgotPassword",
  RESET_PASSWORD: "reset-password",
};

// Error messages
export const ERROR_MESSAGES = {
  REQUIRED: "Trường này là bắt buộc",
  INVALID_EMAIL: "Email không hợp lệ",
  INVALID_PASSWORD: "Mật khẩu phải có ít nhất 8 ký tự",
  INVALID_USERNAME:
    "Tên người dùng phải có ít nhất 3 ký tự và chỉ chứa chữ, số, gạch dưới",
  INVALID_PHONE: "Số điện thoại không hợp lệ",
  INVALID_NAME: "Tên phải có ít nhất 2 ký tự và chỉ chứa chữ cái",
  PASSWORD_MISMATCH: "Mật khẩu không khớp",
  INVALID_RESET_INFO: "Thông tin đặt lại mật khẩu không hợp lệ",
};

// Success messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: "Đăng nhập thành công",
  REGISTER_SUCCESS: "Đăng ký thành công",
  PASSWORD_RESET_SENT: "Hãy kiểm tra email của bạn",
  PASSWORD_RESET_SUCCESS: "Đặt lại mật khẩu thành công",
};

// Error messages for API failures
export const API_ERROR_MESSAGES = {
  LOGIN_FAILED: "Đăng nhập thất bại",
  PASSWORD_RESET_SENT_FAILED: "Không thể  tìm thấy email của bạn ",
  REGISTER_FAILED: "Đăng ký thất bại",
  PASSWORD_RESET_FAILED: "Đặt lại mật khẩu thất bại",
};
